import React, { useEffect, useMemo } from "react";
import { AbsoluteCenter } from "./AbsoluteCenter";
import successIcon from "../assets/success.svg";
import warningIcon from "../assets/warning.svg";
import { useParams } from "react-router";
import { Loader } from "./Loader";
import { useTranslation } from "react-i18next";

export const FBInfo: React.FC = () => {
  const { id } = useParams<{
    id: string;
  }>();
  const { t } = useTranslation();

  const [answer, setAnswer] = React.useState(true);
  const [fetching, setFetching] = React.useState(false);

  useEffect(() => {
    const doFetch = async () => {
      const url = `${
        process.env.REACT_APP_API_HOST
      }/facebook/deletion-confirmation?id=${encodeURIComponent(id!)}`;

      try {
        setFetching(true);
        const res = await fetch(url, {
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        });

        if (res.status === 200) {
          setFetching(false);
          setAnswer(true);
        } else {
          setFetching(false);
          setAnswer(false);
        }
      } catch (err) {
        setFetching(false);
        setAnswer(false);
      }
    };

    if (id) {
      doFetch();
    }
  }, [id]);

  const currentData = useMemo(() => {
    return {
      icon: answer ? successIcon : warningIcon,
      title: answer ? t("fb_data_deleted_title") : t("fb_no_data_title"),
      description: answer
        ? t("fb_data_deleted_description")
        : t("fb_no_data_description"),
    };
  }, [answer]);

  if (fetching) {
    return (
      <AbsoluteCenter>
        <Loader description="Loading" />
      </AbsoluteCenter>
    );
  }
  return (
    <AbsoluteCenter>
      <div
        style={{
          width: "420px",
          background: "linear-gradient(180deg, #306DAE 0%, #063358 100%)",
          border: "1px solid #1E71D3",
          borderRadius: "20px",
          padding: "60px 32px",
        }}
        className="text-white flex flex-col items-center gap-3"
      >
        <img src={currentData.icon} width={50} height={50} alt="Success" />
        <div className="flex flex-col items-center gap-1 text-center">
          <p
            style={{
              fontSize: "20px",
              lineHeight: "30px",
              fontWeight: 500,
            }}
          >
            {currentData.title}
          </p>
          <p>{currentData.description}</p>
        </div>
      </div>
    </AbsoluteCenter>
  );
};
